import React from 'react';
import classnames from 'classnames';
import './index.scss'
import ImgAdapt from "../../../../components/img-adapt";
import IMGNull from '../../../../assets/images/loading_bg_template.png'

const ImageFooter = props => {
    const {data, toLink} = props;
    const {imgs_ = [], style_, height_, margin_} = data;
    //style_ 对应布局类型
    const style = {
        height: `${height_}px`,
        marginBottom: `${margin_}px`
    };
    const cls = classnames('home-imgs-box', {
        'layout-image-main-three': style_ === 4,
        'layout-image-main-six': style_ === 7,
        'layout-image-main-seven': style_ === 8,
        'layout-image-main-nine-1': style_ === 9,
        'layout-image-main-nine-2': style_ === 10,
    });

    return (
        <div className={cls} style={style}>
            {
                imgs_.map((item, index) => {
                    return (
                        <div className="img-box" role="none" key={index} onClick={() => toLink(item.target_)} style={{padding: item.isDefaultCard ? "8px" : ""}}>
                            <ImgAdapt src={item.img_ ? `${item.img_}` : IMGNull} alt=""/>
                        </div>
                    )
                })
            }
        </div>
    )
};
export default ImageFooter
